import { useEffect, useState } from "react";
import { getRiderHistory } from "../../api/client";
import RiderNav from "../../components/RiderNav";
import RiderProfileStatus from "../../components/RiderProfileStatus";
import LoadingIndicator from "../../components/LoadingIndicator";

export default function RiderHistory() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await getRiderHistory();
      setOrders(data);
    } catch {
      setError("Could not load trip history.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const filteredOrders = orders.filter((o) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return (
      o._id.toLowerCase().includes(q) ||
      o.pickup?.address?.toLowerCase().includes(q) ||
      o.dropoff?.address?.toLowerCase().includes(q) ||
      o.user?.name?.toLowerCase().includes(q) ||
      o.user?.phone?.toLowerCase().includes(q)
    );
  });

  return (
    <div className="rider-app">
      <RiderNav />
      <div className="page wide page-with-nav">

      <RiderProfileStatus />

      <div className="brand-header">
        <span className="brand-logo">📜</span>
        <span className="brand-name">Delivery Trip History</span>
        <p className="brand-tagline">Review your completed and past fulfilled deliveries</p>
      </div>

      {error && <p className="error">{error}</p>}

      {!loading && orders.length > 0 && (
        <input
          type="text"
          placeholder="Search by order ID, address, customer name or phone..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ marginBottom: "16px" }}
        />
      )}

      {loading ? (
        <LoadingIndicator label="Loading trip history..." />
      ) : orders.length === 0 ? (
        <div className="empty-state">
          <span className="empty-state-icon">🏁</span>
          <p className="empty-state-text">No past deliveries found.</p>
        </div>
      ) : filteredOrders.length === 0 ? (
        <div className="empty-state">
          <span className="empty-state-icon">🔍</span>
          <p className="empty-state-text">No deliveries match your search.</p>
        </div>
      ) : (
        filteredOrders.map((o) => (
          <div key={o._id} className="rider-card" style={{ marginBottom: "14px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "8px" }}>
              <div>
                <strong>Order #{o._id.slice(-6).toUpperCase()}</strong>
                <p style={{ fontSize: "12px", color: "var(--text-muted)", marginTop: "2px" }}>
                  {new Date(o.updatedAt || o.createdAt).toLocaleString()}
                </p>
              </div>
              <span className={`status-badge ${o.status === "completed" || o.status === "delivered" ? "info" : "danger"}`}>
                {o.status.toUpperCase()}
              </span>
            </div>

            <div className="info-row">
              <span className="label">Customer</span>
              <span className="value">{o.user?.name || "Customer"} ({o.user?.phone || "N/A"})</span>
            </div>
            <div className="info-row">
              <span className="label">Pickup</span>
              <span className="value">{o.pickup?.address}</span>
            </div>
            <div className="info-row">
              <span className="label">Drop-off</span>
              <span className="value">{o.dropoff?.address}</span>
            </div>
            <div className="info-row">
              <span className="label">Payment</span>
              <span className="value" style={{ textTransform: "uppercase" }}>{o.paymentMethod} (₦{o.priceSnapshot?.total})</span>
            </div>
          </div>
        ))
      )}
      </div>
    </div>
  );
}
